module.exports = __webpack_public_path__ + "static/media/checkmark-filled.733c66db.svg";